import { HTTPError } from "ky";
import { useState } from "react";
import { useToast } from "../contexts/ToastContext";
import { login, signup } from "../lib/api";

interface AuthPageProps {
  onAuth: (token: string) => void;
}

export function AuthPage({ onAuth }: AuthPageProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLogin, setIsLogin] = useState(true);
  const { addToast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username || !password) {
      addToast("please enter both username and password.", "error");
      return;
    }

    const normalizedUsername = username.toLowerCase();

    try {
      if (isLogin) {
        const data = await login(normalizedUsername, password);
        onAuth(data.accessToken);
      } else {
        const data = await signup(normalizedUsername, password);
        if (data.message) {
          addToast(`${data.message}. please log in.`, "success");
          setIsLogin(true);
        }
      }
    } catch (err: unknown) {
      if (err instanceof HTTPError) {
        try {
          const errorBody = await err.response.json();
          addToast(errorBody.error || "an unknown error occurred.", "error");
        } catch {
          addToast("an unexpected error occurred.", "error");
        }
      } else {
        addToast("a network error occurred. please try again.", "error");
      }
    }
  };

  return (
    <div className="auth-container">
      <h1 className="title">pass the note</h1>
      <form className="auth-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="username"
          value={username}
          onChange={(e) => setUsername(e.target.value.toLowerCase())}
          className="auth-input"
          autoComplete="username"
        />
        <input
          type="password"
          placeholder="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="auth-input"
          autoComplete={isLogin ? "current-password" : "new-password"}
        />
        <div className="button-group">
          <button type="submit" className="btn btn-primary btn-full" style={{ borderRadius: "77px 70px 98px 71px / 89px 90px 84px 53px" }}>
            {isLogin ? "login" : "sign up"}
          </button>
        </div>
      </form>
      <div className="mt-1">
        <button type="button" onClick={() => setIsLogin(!isLogin)} className="btn-text">
          {isLogin ? "need an account? sign up" : "have an account? log in"}
        </button>
      </div>
    </div>
  );
}
